<template>
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1"
    stroke-linecap="round"
    stroke-linejoin="round"
    ...attributes
  >
    <polyline points="9 18 15 12 9 6" transform="translate(-3,0)"></polyline>
    <polyline points="9 18 15 12 9 6" transform="translate(3,0)"></polyline>
  </svg>
</template>
